import {
  Modal,
  ModalTitle,
  ModalCloseIconButton,
  ModalContent,
  Typography,
  ModalActions,
  ModalActionButton,
} from '@ace-clublabs/shared-component-library';

export interface IRVDowngradeModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  visible: boolean;
}

export const RVDowngradeModal = ({ visible, onCancel, onConfirm }: IRVDowngradeModalProps) => (
  <Modal id="rv-downgrade-modal" open={visible} size="small" onClose={onCancel}>
    <ModalTitle id="rv-downgrade-title" sx={{ marginRight: '1.5rem' }}>
      RV/motorcycle not available for selected benefit level
      <ModalCloseIconButton
        aria-label="Close"
        id="modalCloseButton"
        onClick={() => {
          onCancel();
        }}
      />
    </ModalTitle>
    <ModalContent id="rv-downgrade-content">
      <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
        By continuing, Roadside Assistance for RV/motorcycles will be removed.
      </Typography>
    </ModalContent>
    <ModalActions
      actionLayout={{
        sm: 'shared',
        md: 'shared',
        lg: 'shared',
        xl: 'rightAlign',
      }}
      sx={{
        gap: '0.5rem',
      }}
    >
      <ModalActionButton
        id="rv-downgrade-cancel"
        className="modalActionButton"
        label={'Cancel'}
        onClick={onCancel}
        variant="outlined"
        fullWidth
        sx={{ minWidth: '9rem' }}
      />
      <ModalActionButton
        id="rv-downgrade-continue"
        className="modalActionButton"
        label={'Continue'}
        onClick={onConfirm}
        fullWidth
        sx={{ minWidth: '9rem' }}
      />
    </ModalActions>
  </Modal>
);
